import { de } from '@3pc/lightbox-photoswipe/lib/lang/de';

export const config = {
  mainClass: 'pswp--teddy',
  bgOpacity: 1,
  padding: { top: 100, bottom: 100 },
  closeSVG: `
    <span class="icon icon--close">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-cross"></use>
      </svg>
      <span class="sr-only">${de.closeTitle}</span>
    </span>
  `,
  zoomSVG: `
    <span class="icon icon--zoom">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-magnifier-plus"></use>
      </svg>
      <span class="sr-only">${de.zoomTitle}</span>
    </span>
  `,
  arrowPrevSVG: `
    <span
    class="arrow arrow-left"
    aria-label="${de.arrowPrevTitle}"
    data-glide-dir="<"
    >
        <span class="glide__control-text sr-only">${de.arrowPrevTitle}</span>
      <i class="icon icon--pointer-left"></i>
      </span>

    </span>
  `,
  arrowNextSVG: `
    <span class="arrow arrow-right">
      <i class="icon icon--pointer-right"></i>
      <span class="glide__control-text sr-only">${de.arrowNextTitle}</span>
    </span>
  `,
  appendUIElementsToBottom: ['counter', 'arrowPrev', 'arrowNext'],
  defaultDialogTitle: 'Image Galerie',
  showCopyrightUnderCaption: true,
};

export const fixCounter = instance => {
  instance.pswpLightboxInstance.on('change', () => {
    const pswp = instance.pswpLightboxInstance.pswp;
    const counter = pswp.element.querySelector('.pswp__counter');
    const counterStr = `<span class="pswp__counter-inner"><span class="pswp__counter-current">${
      pswp.currIndex + 1
    }</span> <span aria-hidden="true">/</span><span class="sr-only">${
      pswp.options.indexIndicatorSep
    }</span> ${pswp.getNumItems()}</span>`;

    setTimeout(() => {
      counter.innerHTML = counterStr;
    }, 0);
  });
};
